import { useMutation, useQueryClient } from '@tanstack/react-query';
import { counterpartyService } from '@/services/counterparty/counterparty-service';
import { counterpartyKeys } from '@/services/query-keys/counterparty-keys';
import { tradesKeys } from '@/services/query-keys/trades-keys';

export const useCreateCounterparty = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: Record<string, unknown>) => counterpartyService.createAgreement(0, data), // Passing 0 for new counterparty creation
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: counterpartyKeys.lists() });
      queryClient.invalidateQueries({ queryKey: tradesKeys.counterparties() });
    },
  });
};
